if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;

        this.initializeCart();
      }

      initializeCart() {
        this.cart = document.querySelector('cart-drawer');
        if (this.cart) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.initializeCart();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Enhanced debugging for form submission
        console.log("🔄 Form submission handler triggered");
        console.log("📋 Form details:", {
          formId: this.form.id,
          formAction: this.form.action,
          formElements: this.form.elements.length
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Get all form inputs for debugging
        console.log("📋 All form inputs before FormData creation:");
        Array.from(this.form.elements).forEach(element => {
          if (element.name) {
            console.log(`   ${element.name}: ${element.value}`);
          }
        });
        
        // Log the quantity at submission time (with safe null check)
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        console.log("🚀 Quantity at submission time:", quantityInput ? quantityInput.value : "not found", "in form:", this.form.id);
        
        // If quantity input is missing, try to create one
        if (!quantityInput) {
          console.log("⚠️ Quantity input not found in form, creating one...");
          
          // Get the appropriate quantity from the main product
          const mainProduct = document.querySelector('.main-product');
          if (mainProduct) {
            const packSize = mainProduct.getAttribute('ref2')?.replace(/\D/g, '') || '2';
            const productType = mainProduct.getAttribute('ref') || 'italian-riviera';
            const isBundle = productType?.includes('bundle') || productType?.includes('duo') || productType === 'sample-pack';
            
            // Get the correct quantity for the current pack size
            try {
              // This is defensive to avoid errors if quantityMappings isn't defined
              const qtyMap = window.quantityMappings ? 
                (isBundle ? window.quantityMappings.bundle : window.quantityMappings.single) : 
                { '1': 1, '2': 2, '3': 4 };
              const mappedQuantity = qtyMap[packSize] || (isBundle ? 1 : 2);
              
              console.log(`🔧 Creating quantity input with value: ${mappedQuantity}`);
              
              // Create and add the quantity input
              const newQuantityInput = document.createElement('input');
              newQuantityInput.type = 'hidden';
              newQuantityInput.name = 'quantity';
              newQuantityInput.value = mappedQuantity;
              this.form.appendChild(newQuantityInput);
              
              // Update the formData
              formData.set('quantity', mappedQuantity.toString());
              console.log(`✅ Added quantity=${mappedQuantity} to form and formData`);
            } catch (error) {
              console.error("❌ Error creating quantity input:", error);
            }
          }
        }
        
        // Log all formData entries for debug
        console.log("📦 FormData entries after creation:");
        try {
          for (let pair of formData.entries()) {
            console.log(`   ${pair[0]}: ${pair[1]}`);
          }
        } catch (error) {
          console.error("❌ Error logging formData entries:", error);
        }
        
        formData.append('sections', 'cart-drawer,cart_drawer,cart-items,main-cart-items,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            this.error = false;

            if (this.cart) {
              this.cart.renderContents(response);
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response
            });
          })
          .catch((e) => {
            this.error = true;
            this.handleErrorMessage('An error occurred while adding to cart');
            console.error('Error in cart add:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              if (this.cart) {
                this.cart.classList.remove('is-empty');
              }
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
